export default {
  bsetuLogo: require("./appLogo.png"),
  userProfile: require("./userProfile.png"),
  placeholder: require("./placeholder.png"),
};
